import { render, staticRenderFns } from "./Product-Tab-Logs.vue?vue&type=template&id=0eb7c8ce"
import script from "./Product-Tab-Logs.vue?vue&type=script&lang=js"
export * from "./Product-Tab-Logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports